import gql from "graphql-tag";

export const GET_AGENT_DETAIL_REPORT = gql`
  query (
    $agentId: String!
    $skip: Int
    $take: Int
    $fromDate: String
    $toDate: String
    $orderBy: String
    $orderDirection: String
  ) {
    agentSummaryReport(
      agentId: $agentId
      skip: $skip
      take: $take
      fromDate: $fromDate
      toDate: $toDate
      orderBy: $orderBy
      orderDirection: $orderDirection
    ) {
      aggregation {
        totalDownlineDepositCount
        totalDownlineDepositAmount
        totalDownlineWithdrawalCount
        totalDownlineWithdrawalAmount
        totalDownlineRebateAmount
        totalDownlineBonusAmount
        totalNetProfit
        totalAPEarned
        totalDownlineCount
        newDownlineCount
      }
      result {
        downlineId
        downlineName
        downlineUsername
        downlineTelegramId
        downlinePhoneNo
        downlineDepositCount
        downlineDepositAmount
        downlineWithdrawalCount
        downlineWithdrawalAmount
        downlineRebateAmount
        downlineBonusAmount
        netProfit
        APEarned
        downlineSerialNo
      }
    }
  }
`;
